import { IonButton, IonInput } from "@ionic/react";
import { useHistory } from "react-router";
import { LogIn } from "../api";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setInfo, setToken } from "../store/actions";

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [log, setLog] = useState();
  const [pass, setPass] = useState();
  const [error, setError] = useState();
  const onLogin = async () => {
    if (log && pass) {
      await LogIn(log, pass).then((e) => {
        if (e.data.error) {
          setError(e.data.error);
        } else {
          dispatch(setToken(e.data.data.session));
          dispatch(setInfo(log));
          history.push("/tables");
        }
      });
    }
  };
  return (
    <div className="login-page">
      <div className="cont">
        <div className="login-cont">
          <div className="title">Войти</div>
          <div className="inputs">
            <div className="cont-input">
              <IonInput
                value={log}
                fill="outline"
                className="input-report"
                placeholder="Логин"
                onChange={(e) => setLog(e.target.value)}
              ></IonInput>
            </div>
            <div className="cont-input">
              <IonInput
                value={pass}
                className="input-report"
                type="password"
                fill="outline"
                placeholder="Пароль"
                onChange={(e) => setPass(e.target.value)}
              ></IonInput>
            </div>
            {error && <div className="error">{error}</div>}
          </div>
          <div className={`button-ui`} onClick={() => onLogin()}>
            Продолжить
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
